import * as React from 'react';
import { Alert, Button, Card } from 'react-bootstrap';
import { useAdminContext } from '../../contexts/AdminContext';

export default function UpdateOwes() {
  const { updateUserOwes, getTotalUserList } = useAdminContext();
  const [buttonDisabled, setButtonDisabled] = React.useState<boolean>(false);

  async function updateUserOwesFromTotalUserList() {
    setButtonDisabled(true);
    updateUserOwes((await getTotalUserList()).map(user => user.uid))
  }

  return (
    <Card>
      <Card.Header>
        <h2>Update Owes</h2>
        <Alert variant='danger'>
          Does a METRIC FUCKTONE of un optimised background jobs, and shouldn't even be needed anyway because we update OWEs whenever payments change. 
        </Alert>
      </Card.Header>
      <Card.Body className="d-flex justify-content-center">
        <Button 
          variant='danger'
          disabled={buttonDisabled}
          onClick={() => updateUserOwesFromTotalUserList()}
        >Update owes</Button>
      </Card.Body>
    </Card>
  )
}
